<template>
  <!-- <div class="wrapper" @click.prevent="$emit('click')"> -->
  <div class="wrapper" @click="scrollTo">
    <div class="container">
      <div class="icon-area">
        <div class="icon-container">
          <gl-icon :icon="icon" />
          <transition>
            <gl-icon-warning class="warning-icon" v-if="hasError" />
          </transition>
        </div>
      </div>
      <div class="content">
        <div class="title">{{ title }}</div>
        <div v-if="!hasError" class="summary">
          <slot />
        </div>
        <div v-if="hasError" class="summary">
          <gl-error-text :errors="errors" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sleep } from '@/util/time'

export default {
  props: {
    scrollToId: String,
    icon: String,
    title: String,
    summary: String,
    warn: Boolean,
    errors: Array,
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasError() {
      return this.errors && this.errors.length > 0
    },
  },
  methods: {
    async scrollTo() {
      this.$scrollTo(`#${this.scrollToId}`, 120, {
        easing: 'ease-out',
        offset: -(72 + 32),
      })

      // TODO 直接DOMにアクセスしたくない。EventBus使う？
      const elem = document.getElementById(this.scrollToId)
      if (!elem) {
        return
      }
      elem.classList.add('bounce')
      await sleep(900)
      elem.classList.remove('bounce')
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  transition: background-color 0.2s ease-in-out;

  .container {
    color: #fff;
    cursor: pointer;
    display: flex;
    flex: 1;
    padding-bottom: var(--spacing-medium);
    padding-right: var(--spacing-medium);
    padding-top: var(--spacing-medium);
  }

  &:hover {
    background: #4a5664;

    .icon-container {
      border-radius: 5px;
    }
  }
}

.icon-area {
  .icon-container {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    margin-left: var(--spacing-medium);
    margin-right: var(--spacing-medium);
    padding: var(--spacing-small);
    position: relative;

    transition: border-radius 0.2s ease-in-out;
  }

  .gl-icon {
    color: #fff;
  }

  .warning-icon {
    position: absolute;
    bottom: 0;
    right: 0;
    color: var(--color-warn);
  }
}

.content {
  flex: 1;
}

.title {
  line-height: 40px;
  font-size: var(--font-size-normal);
}

.summary {
  color: var(--color-secondary-text);
  font-size: var(--font-size-small);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
